import { SkeletonBlock } from '../../../ToolkitV2/Skeleton/Skeleton';
import { Panel } from '../Panels/shared/Panel/Panel';

import * as Styled from './Loading.styled';

import { Spacer } from '../../../../helpers/genericStyles';
import { ORIENTATION } from '../../../ToolkitV2/CardV2/Card.typed';
import { SkeletonInputs } from './SkeletonInputs';

const Loading = () => {
  return (
    <Styled.Container>
      <Panel>
        <SkeletonBlock w="181px" h="48px" />
        <Spacer marginBottom="M24" />
        <SkeletonBlock w="299px" h="24px" />
        <Spacer marginBottom="S8" />
        <SkeletonBlock w="100%" h="24px" />
        <Spacer marginBottom="M16" />
        <Styled.SkeletonAdCard
          orientationSmall={ORIENTATION.HORIZONTAL}
          header={
            <div>
              <SkeletonBlock w="100%" wMedium="323px" h="14px" />
              <Spacer marginBottom="S8" />
              <SkeletonBlock w="60%" wMedium="194px" h="14px" />
            </div>
          }
          image={<SkeletonBlock w="180px" h="100px" />}
          paddingSmall="S12"
          backgroundColor="OFFWHITE"
        />
      </Panel>
      <Panel>
        <SkeletonBlock w="299px" h="24px" />
        <Spacer marginBottom="M24" />
        <SkeletonInputs arrayLength={6} />
        <SkeletonBlock w="126px" h="32px" />
        <Spacer marginBottom="S8" />
        <SkeletonBlock w="100%" h="32px" />

        <Spacer marginBottom="M24" />
        <SkeletonBlock w="100%" h="464px" />
      </Panel>
      <Panel>
        <SkeletonBlock w="299px" h="24px" />
        <Spacer marginBottom="M24" />
        <SkeletonInputs arrayLength={7} />
        <SkeletonBlock w="126px" h="32px" />
        <Spacer marginBottom="S8" />
        <SkeletonBlock w="100%" h="32px" />
      </Panel>
      {Array(4)
        .fill(null)
        .map((_item: null, index: number) => {
          const key = `skeleton-panel-${index}`;

          return (
            <Panel key={key}>
              <SkeletonBlock w="395px" h="24px" />
            </Panel>
          );
        })}
      <Panel>
        <Styled.SkeletonSubmitButton w="160px" h="48px" />
      </Panel>
    </Styled.Container>
  );
};

export { Loading };
